import { JustificationCounts } from '@schooly/api';
import { Counter } from '@schooly/style';
import { FC } from 'react';

type JustificationCountersProps = {
  counts: JustificationCounts;
};

export const JustificationCounters: FC<JustificationCountersProps> = ({ counts }) => {
  const { expired, pending, submitted } = counts;

  const expiredCount = expired;
  const pendingAndSubmittedCount = pending + submitted;

  return (
    <>
      {!!expiredCount && (
        <Counter styleType="error" shape="circle" inverse sx={{ ml: 0.5 }}>
          {expiredCount}
        </Counter>
      )}
      {!!pendingAndSubmittedCount && (
        <Counter styleType="warning" shape="circle" inverse sx={{ ml: 0.5 }}>
          {pendingAndSubmittedCount}
        </Counter>
      )}
    </>
  );
};
